import { render, staticRenderFns } from "./DeleteTableDialog.vue?vue&type=template&id=4a26cae5&scoped=true&"
import script from "./DeleteTableDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteTableDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteTableDialog.vue?vue&type=style&index=0&id=4a26cae5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a26cae5",
  null
  
)

export default component.exports